const bucket_header = [
			{ title: "Bucket, GET", description: "Excessive wear or damage, cracks" },
			{ title: "Bucket cylinder & linkage", description: "Excessive wear, damage, leaks, lubricate" },
			{ title: "Stick, cylinder", description: "Wear, damage, leaks, lubricate" },
			{ title: "Boom, cylinders", description: "Wear, damage, leaks, lubricate" },
			{ title: "Underneath machine", description: "Leaks, damage" },
			{ title: "Carbody", description: "Cracks, damage" },
			{ title: "Undercarriage", description: "Wear, damage, tension" },
			{ title: "Steps and handolds", description: "Condition, cleanliness" },
			{ title: "Batteries & hold downs", description: "Cleanliness, loose bolts & nuts" },
			{ title: "Windshield wipers & washers", description: "Wear, damage, fluid level" },
			{ title: "Fire extinguisher", description: "Charge, damage" },
			{ title: "Engine coolant", description: "Fluid level" },
			{ title: "Primary/secondary fuel filters", description: "Leaks, drain water seperator" },
			{ title: "Air filter", description: "Restriction indicator" },
			{ title: "Hydraulic oil tank", description: "Fluid level, damage, leaks" },
			{ title: "Hydraulic oil filter", description: "Leaks" },
			{ title: "Radiator", description: "Fin blockage, leaks" },
			{ title: "Hydraulic oil cooler", description: "Fin blockage, leaks" },
			{ title: "AC condenser", description: "Fin blockage, leaks" },
			{ title: "Lights", description: "Damage" },
			{ title: "Mirrors", description: "Damage, proper adjustment, cleanliness" },
			{ title: "Engine oil filter", description: "Leaks" },
			{ title: "Hydraulic oil filters", description: "Leaks" },
			{ title: "Overall machine", description: "Loose or missing nuts & bolts, loose guards, cleanliness" },
			{ title: "Engine oil", description: "Fluid level" },
			{ title: "Swing gear oil", description: "Fluid level, leaks" },
			{ title: "Fuel tank", description: "Fuel level, damage, leaks" },
			{ title: "Diesel exhaust fluid (DEF) tank (if equipped)", description: "Fluid level, check for debris buildup" },
			{ title: "All hoses", description: "Cracks, wear spots, leaks" },
			{ title: "All belts", description: "Tension, wear, cracks" },
			{ title: "Overall engine compartment", description: "Trash or dirt buildup, leaks" },
			{ title: "Seat", description: "Adjustment-height/weight, able to reach pedals" },
			{ title: "Seat belt and mounting", description: "Damage, wear, adjustment, age of seatbelt, installation date" },
			{ title: "Horn, backup alarm, lights", description: "Proper function" },
			{ title: "Indicators", description: "Proper function" },
			{ title: "Monitor panel", description: "Proper function" },
			{ title: "Switches", description: "Proper function" },
			{ title: "Mirrors", description: "Proper adjustment" },
			{ title: "Heating system", description: "Proper function" },
			{ title: "ROPS", description: "Damage, loose mounting bolts" },
			{ title: "Cooling system", description: "Proper function" },
			{ title: "Cab air filter", description: "Dirt, dust" },
			{ title: "Overall cab interior", description: "Cleanliness" },
		]

export default bucket_header;